export const LOAD_OSD_VIEWER_CONFIG = 'LOAD_OSD_VIEWER_CONFIG';
export const UPDATE_OSD_VIEWER_CONFIG = 'UPDATE_OSD_VIEWER_CONFIG';
